import { useState, useEffect } from 'react'

/** [draggedElementRef] will be moved on [draggedByElementRef] press */
export default function useDraggable(draggedElementRef, draggedByElementRef = draggedElementRef) {
  const [{ dx, dy }, setOffset] = useState({ dx: 0, dy: 0 })

  const [dragging, setDragging] = useState(false)

  useEffect(() => {
    const handleMouseDown = (event) => {
      const startX = event.pageX - dx
      const startY = event.pageY - dy

      const handleMouseMove = (event) => {
        setDragging(true)
        const newDx = event.pageX - startX
        const newDy = event.pageY - startY
        setOffset({ dx: newDx, dy: newDy })
      }

      document.addEventListener('mousemove', handleMouseMove)

      document.addEventListener(
        'mouseup',
        () => {
          setTimeout(() => {
            setDragging(false)
          }, 200)
          document.removeEventListener('mousemove', handleMouseMove)
        },
        { once: true }
      )
    }

    draggedByElementRef.current.addEventListener('mousedown', handleMouseDown)

    return () => {
      draggedByElementRef.current && draggedByElementRef.current.removeEventListener('mousedown', handleMouseDown)
    }
  }, [dx, dy])

  useEffect(() => {
    draggedElementRef.current.style.transform = `translate3d(${dx}px, ${dy}px, 0)`
  }, [dx, dy])

  return { dragging }
}
